export const rootRoute = '/';
export const defaultRoute = '/dashboard/home';

export const onboardingRoutePrefix = '/partner-onboarding/';
export const onboardingAddNewMerchantVenueRoute = '/partner-onboarding/new-venue';

export const menuEditorRoutePrefix = '/menu-editor/';
export const menuEditorEntrypointRoute = '/menu-editor/my-menu';
